import { ContentBox } from "@arelia-components/ui-atoms/ContentBox";
import Header from "@arelia-components/layout/Header";
import { useLocation, useNavigate } from "react-router-dom";
import { PATHS } from "src/routes";
import { useEffect } from "react";
import { useQuery } from "react-query";
import { TotalVideoMetrics } from "./models";
import { http } from "src/api/http";
import MyVideosPresenter from "./MyVideosPresenter";
import { useConfiguration } from "src/api/configuration";

export default function MyVideosContainer() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { data, isLoading } = useQuery<TotalVideoMetrics[]>({
    queryKey: ["useSocialTotalVideoMetrics"],
    queryFn: () => http(`/api/my-social/total-video`)
  });
  const { data: configuration } = useConfiguration();

  const enablePosting = configuration?.flags?.EnablePosting === true

  const navOptions = [
    { value: PATHS.SOCIAL + "/dashboard", label: "Dashboard" },
    { value: PATHS.SOCIAL + "/my-videos", label: "My Videos" },
    ...(enablePosting ? [{ value: PATHS.SOCIAL + "/create-a-post", label: "Create a post" }] : [])
  ];

  useEffect(() => {
    if (pathname === PATHS.SOCIAL) {
      navigate(PATHS.SOCIAL + "/dashboard");
    }
  }, [pathname]);

  return (
    <ContentBox>
      <Header
        title="My Social"
        navOptions={navOptions}
        navValue={pathname}
        setNavValue={navigate}
      />
      <MyVideosPresenter data={data as TotalVideoMetrics[]} isLoading={isLoading} />
    </ContentBox>
  );
}
